import CloseButton from "../CloseButton";

import "./style.css";

function CustomSliderModalV2({ show, setShow, children, title }) {
    return (
        <div id='custom-slider-modal-sticky-wrapper'>
            <div id='custom-slider-modal-wrapper' style={{ height: show ? "100vh" : 0 }}>
                <div id='custom-slider-modal-v2' style={show ? { top: "0%" } : {}}>
                    <CloseButton onClick={() => {
                        setShow(false);
                    }} />
                    <h4>{title}</h4>
                    {
                        children
                    }
                </div>
            </div>
        </div>
    );
}

export default CustomSliderModalV2;